import { useEffect } from 'react';
import { useListContext } from 'framework/list';
import { useShowContext } from 'framework/show';
import { usePrevious } from 'framework/utils';
import { TimelineContextData } from 'framework/ui/timeline';

interface CandidateTimelineShowData {
  timelineAppendRequestId?: number;
}

const CandidateTimelineHeader = () => {
  const { reloadData = () => {} }: TimelineContextData = useListContext();
  const { data } = useShowContext<CandidateTimelineShowData>();
  const previousTimelineAppendRequestId = usePrevious(data?.timelineAppendRequestId);

  useEffect(() => {
    if (!data?.timelineAppendRequestId || previousTimelineAppendRequestId === data.timelineAppendRequestId) {
      return;
    }

    reloadData();
  }, [data?.timelineAppendRequestId, previousTimelineAppendRequestId, reloadData]);

  return null;
};

export default CandidateTimelineHeader;
